import React from 'react';
import t from '@jetshop/intl';
import { trackPageEvent } from '@jetshop/core/analytics/tracking';
import Analytics from '@jetshop/core/analytics/Analytics';
import SearchPageBehaviour from '@jetshop/ui/Search/SearchPage/SearchPageBehaviour';
import theme from '@jetshop/ui/utils/theme';
import SearchResults from './SearchResults';
import EmptySearchResults from './EmptySearchResults';
import styled from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import SearchQuery from './SearchQuery.gql';

import Layout from '../Layout/Layout';

export const Header = styled('header')`
  background: white;
`;

export const Matches = styled('div')`
  text-align: center;
  color: inherit;
  padding: 1.5rem 0;
`;

const LeftAsideWrapper = styled('div')`
  margin-right: 1rem;
  width: 20%;
`;

const ContentContainer = styled('div')`
  margin-top: 0.8rem;
  width: 80%;
`;

export const Container = styled(MaxWidth)`
  padding: 20px;
  background: ${theme('colors.white')};
  flex-flow: row;

  ${LeftAsideWrapper} ~ ${ContentContainer} {
    border-left: 1px solid #eee;
    padding-left: 1rem;
  }
`;

export const Wrapper = styled('div')``;

const renderResults = searchProps =>
  searchProps.total > 0 || searchProps.loading ? (
    <SearchResults {...searchProps} />
  ) : (
    <EmptySearchResults
      key={searchProps.term}
      term={searchProps.term}
      result={searchProps.result}
    />
  );

const SearchPage = routeProps => {
  const { pathname, search } = routeProps.location;
  return (
    <Layout hideCategoryTree>
      <Analytics
        key={search}
        event={trackPageEvent({
          pathname: `${pathname}${search}`
        })}
      />
      <SearchPageBehaviour searchQuery={SearchQuery} {...routeProps}>
        {({ error, ...searchProps }) =>
          error ? (
            <div error={error}>{t('An error occured. Please try again!')}</div>
          ) : (
            renderResults(searchProps)
          )
        }
      </SearchPageBehaviour>
    </Layout>
  );
};

export default SearchPage;
